export const RESELLER_LOGO_SVG = {
  width: '1000',
  height: '480',
  viewBox: '0 0 1000 480',
};
